module.exports = __webpack_public_path__ + "static/media/limao.232f325a.png";